module.exports = __webpack_public_path__ + "77aa1413daea4555bc4afd93a7666962.svg";